import { render, staticRenderFns } from "./BillingReviewer.vue?vue&type=template&id=08b4f35f&"
import script from "./BillingReviewer.vue?vue&type=script&lang=js&"
export * from "./BillingReviewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports